module.exports = __webpack_public_path__ + "img/loudspeaker.cfe93d7.png";